import React, { useReducer, useState, useContext } from 'react';
import { DeviceEventEmitter } from 'react-native';

import WooService from '../services/WooService';
import { CartContext } from "./CartContext";

const ProductsContext = React.createContext();

const getAllProducts = async () => {
    const wooService = new WooService();
    return await wooService.getWooProducts();
}

const getVariations = async (productId, productName) => {
    const wooService = new WooService();
    return await wooService.getWooVariations(productId, productName);
}

const parentProductsReducer = (parentProducts, action) => {
    switch (action.type) {
        case 'push':
            const newValue = parentProducts;
            newValue.push(action.payload);
            return newValue;
        case 'pop':
            return action.payload;
        default:
            return parentProducts;
    }
}

const ProductsProvider = ({ children }) => {
    const [products, setProducts] = useState([]);
    const [allProducts, setAllProducts] = useState([]);
    const [varProducts, setVarProducts] = useState([]);
    const [parentProducts, dispatchPrevious] = useReducer(parentProductsReducer, []);
    const { setItem, removeItem, inCart } = useContext(CartContext);

    const loadProducts = async () => {
        const loadedProducts = await getAllProducts();
        setAllProducts(loadedProducts);
        DeviceEventEmitter.emit('ready', {});
    };

    const getCategoryProducts = (categoryId) => {
        let categoryProducts = [];
        for (const product of allProducts) {
            if (product.categories.find(category => category === categoryId)) {
                const foundProduct = product;
                foundProduct.quantity = inCart(product.id);
                categoryProducts.push(foundProduct);
            }
        };
        setProducts(categoryProducts);
    };

    const pushProducts = () => {
        dispatchPrevious({ type: 'push', payload: products });
    }

    const popProducts = (callback) => {
        let newValue = parentProducts;
        let currentProducts = newValue.pop();
        console.log("currentProducts: ", currentProducts);
        console.log("newValue: ", newValue);

        setProducts(currentProducts);
        console.log("parent Products: ", parentProducts);

        dispatchPrevious({ type: 'pop', payload: newValue });
        if (!currentProducts) {
            currentProducts = [];
            callback();
        }
    }

    const updateSelectedProducts = (newItem) => {
        const updatedProducts = products.map(item => {
            return item.id == newItem.id ? newItem : item;
        });
        setProducts(updatedProducts);
        if (newItem.quantity > 0) {
            setItem(newItem);
        } else {
            removeItem(newItem);
        }
    }

    return (
        <ProductsContext.Provider value={{ products, allProducts, loadProducts, setProducts, pushProducts, popProducts, getCategoryProducts, getVariations, updateSelectedProducts }}>
            {children}
        </ProductsContext.Provider>
    );
};

export { ProductsContext, ProductsProvider };